import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Berth, BerthVisit } from '@portbase/bezoekschip-service-typescriptmodels';
import { AbstractValueAccessorComponent } from 'src/app/common/component/value-accessor.component';
import { berthInputFormatter, openConfirmationModalWithCallback, sendQuery } from 'src/app/common/utils';
import { VisitContext } from '../../visit-context';
import { ModalConfirmAutofocus, ModalConfirmAutofocusData } from 'src/app/common/modal/modal-confirm.component';

@Component({
  selector: 'app-select-berth',
  templateUrl: './select-berth.component.html',
  styleUrls: ['./select-berth.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SelectBerthComponent extends AbstractValueAccessorComponent<BerthVisit> {

  context = VisitContext;

  @Input()
  berthVisit: BerthVisit;

  @Input()
  isBerthOfTransfer: boolean;

  @Input()
  firstBerth: boolean;

  @Input() disabled: boolean;

  private readonly _portUnCode: string;
  private currentBerth: Berth;

  constructor() {
    super();
    this._portUnCode = VisitContext.visit.portOfCall.port.locationUnCode;
  }

  ngOnInit() {
    this.currentBerth = this.berthVisit?.berth;
  }

  get value(): BerthVisit {
    return this.berthVisit;
  }

  writeValue(value: BerthVisit): void {
    this.berthVisit = value;
    this.currentBerth = this.berthVisit?.berth;
  }

  public onBerthChanged(newBerth: Berth): void {
    if (newBerth) {
      if (this.firstBerth) {
        if (this.context.hasEntryDependency() && newBerth.berthGroupCode !== this.currentBerth?.berthGroupCode) {
          openConfirmationModalWithCallback((confirmed) => {
            if (confirmed) {
              this.context.clearDependency();
              this.resetBollardAndPositions();
              this.updateBerth(newBerth);
            } else {
              this.updateBerth(this.currentBerth);
            }
            this.context.updateCalculatedEtas();
          }, ModalConfirmAutofocus, <ModalConfirmAutofocusData>{
            type: "warning",
            title: "Cancel dependency on vessel",
            message: "Please note that you did change the berth while there is a dependency on vessel.",
            question: "Do you want to cancel the dependency on vessel?",
            confirmText: "Yes",
            cancelText: "No"
          }, 'static');
          return;
        }
        this.context.updateCalculatedEtas();
      }
      this.resetBollardAndPositions();
      this.updateBerth(newBerth);
    }
  }

  private updateBerth(newBerth: Berth): void {
    this.berthVisit.berth = this.currentBerth = newBerth;
  }

  private resetBollardAndPositions(): void {
    this.berthVisit.bollardFrom = null;
    this.berthVisit.bollardTo = null;
    this.berthVisit.endPosition =  null;
    this.berthVisit.startPosition = null;
  }

  protected readonly berthInputFormatter = berthInputFormatter;

  searchBerth = (term) => sendQuery(
    'com.portbase.bezoekschip.common.api.visit.FindBerthsAndBuoys',
    { term: term, portUnCode: this._portUnCode }
  );
}
